import { CheckoutPaymentMethod } from "./PaymentMethod.ts";

export type CustomerInformation = {
  email: string;
  firstName: string;
  lastName: string;
};

export type NormasTeachingCheckoutFormData = {
  customer: CustomerInformation;
  countryCode?: string;
  number?: string;
  dialCode?: string;
  invoiceRequired: boolean;
  businessType?: string | undefined;
  businessName?: string | undefined;
  pec?: string | undefined;
  sdiCode?: string | undefined;
  vat?: string | undefined;
  address?:
    | {
        street?: string;
        cap?: string;
        city?: string;
        province?: string;
      }
    | undefined;
  taxCode?: string | undefined;
  privacyPolicyAccepted: boolean;
  additionalTerms: boolean;
  participants: CustomerInformation[] | [];
  bundleParticipants: {
    products: {
      id: string;
      priceInCents: { amount: number; currency: string };
      promos?: Array<{
        _id: string;
        bonuses: Array<
          | {
              type: "all_you_can_speak";
              lessonsCountedPerWeek: number;
              activeFrom?: string;
              activeTo?: string;
            }
          | { type: "extra_lessons"; extraLessons: number }
          | { type: "extra_weeks"; extraWeeks: number }
        >;
      }>;
    }[];
    customer: CustomerInformation;
  }[];
  paymentMethod: CheckoutPaymentMethod;
  numberOfInstallments?: number;
  coupon?: {
    _id: string;
    couponCode: string;
    value: number;
  };
  promos?: Array<{
    _id: string;
    bonuses: Array<
      | {
          type: "all_you_can_speak";
          lessonsCountedPerWeek: number;
          activeFrom?: string;
          activeTo?: string;
        }
      | { type: "extra_lessons"; extraLessons: number }
      | { type: "extra_weeks"; extraWeeks: number }
    >;
  }>;
};

export enum ItemType {
  Product = "product",
  Bundle = "bundle",
}
